var MDB = window.MDB || {};
MDB.Media = MDB.Media || {};


$.extend(MDB.Media, {
    initEditor: function () {
        var builder = MDB.KendoConfigBuilder;
        var crudServiceBaseUrl = '/api/Media/';
        var mediaTypeSelector = $('#media-type-selector');
        var divisionSelector = $('#division-selector');
        var gridSelector = $('#grid');
       
        var ds = new kendo.data.DataSource({
            transport: {
                read: function (options) {
                    var params = '?' + $.param({ mediaType: mediaTypeSelector.val() });
                    builder.dataSourceTransportFunction(crudServiceBaseUrl + params, 'GET', options);
                },
                create: function (options) {
                    builder.dataSourceTransportFunction(crudServiceBaseUrl, 'POST', options);
                },
                update: function (options) {
                    builder.dataSourceTransportFunction(crudServiceBaseUrl, 'PUT', options);
                }
            },
            pageSize: 20,
            schema: {
                model: {
                    id: 'Id',
                    fields: {
                        Id: { editable: false },
                        DivisionId: {},
                        ExternalUrl: {nullable: true},
                        IsExternal: {editable: false},
                        Type: {editable: true},
                        Name: {}
                    }
                }
            },
            error: function (e) {
                this.cancelChanges();
                MDB.alert(builder.getWebApiErrorsMessage(e))
            }
        });
       
        var gridConfig = {
            autoBind: true,
            dataSource: ds,
            columnMenu: true,
            pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
            columns: [
                {
                    field: 'DivisionId',
                    title: MDB.loadResourceString('MediaEditModel_DivisionId_DisplayName'),
                    template: function (item) {
                        return divisionSelector.find('[value="' + item.DivisionId + '"]').text() 
                    },
                    editor: function (e, opts) {
                        builder.gridDropdownEditor(e, opts.field, divisionSelector, undefined, opts);
                    }
                }, {
                    field: 'ExternalUrl',
                    title: MDB.loadResourceString('MediaEditModel_ExternalUrl_DisplayName'),
                    editor: function (e, opts) {
                        if (opts.model.isNew() || opts.model.IsExternal){
                            builder.gridTextBoxEditor(e,  opts, {
                                'required': 'required'
                            });
                        } else {
                            e.text(opts.model[opts.field]);
                        }
                    }
                }, {
                    field: 'IsExternal',
                    title: MDB.loadResourceString('MediaEditModel_IsExternal_DisplayName'),
                    template: builder.gridBooleanYesNoTemplate('IsExternal')
                }, {
                    field: 'Type',
                    title: MDB.loadResourceString('MediaEditModel_Type_DisplayName'),
                    editor: function (e, opts) {
                        var isNew = opts.model.isNew();
                        var shouldDisplayValue = !isNew;
                       
                        if (isNew){
                            var value = mediaTypeSelector.val();
                           
                            if (value){
                                value = mediaTypeSelector.find('option[value="' + value + '"]').text();
                               
                                shouldDisplayValue = true;
                                opts.model[opts.field] = value;
                            } else{
                                var availableOpts = mediaTypeSelector.find('option:not([value=""])');
                                builder.gridDropdownEditor(e,  opts.field, availableOpts, undefined, opts);
                            }
                        }
                       
                        if (shouldDisplayValue){
                            e.text(opts.model[opts.field]);
                        }
                    }
                },{
                    field: 'Name',
                    title: MDB.loadResourceString('MediaEditModel_Name_DisplayName')
                },
                MDB.KendoConfigBuilder.gridCommandColumn(['edit'])
            ],
            sortable: true,
            messages: {
                commands: builder.commandLabels(),
                noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
            },
            toolbar: ['create'],
            editable: 'inline'
        };
       
        var grid = builder.reloadableGrid(gridSelector, gridConfig);
        mediaTypeSelector.on('change', grid.reload);
    }
});